export enum AssetTypes {
    Datasets = 'datasets',
    Models = 'models',
    Results = 'results',
}
